'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var log = require('debug')('ipfs:components:init');

var PeerId = require('peer-id');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var PeerInfo = require('peer-info');

var mergeOptions = require('merge-options');

var getDefaultConfig = require('../runtime/config-nodejs.js');

var createRepo = require('../runtime/repo-nodejs');

var Keychain = require('libp2p-keychain');

var NoKeychain = require('./no-keychain');

var mortice = require('mortice');

var _require2 = require('ipld-dag-pb'),
    DAGNode = _require2.DAGNode;

var UnixFs = require('ipfs-unixfs');

var multicodec = require('multicodec');

var _require3 = require('../errors'),
    AlreadyInitializingError = _require3.AlreadyInitializingError,
    AlreadyInitializedError = _require3.AlreadyInitializedError,
    NotStartedError = _require3.NotStartedError,
    NotEnabledError = _require3.NotEnabledError;

var BlockService = require('ipfs-block-service');

var Ipld = require('ipld');

var getDefaultIpldOptions = require('../runtime/ipld-nodejs');

var createPreloader = require('../preload');

var ERR_REPO_NOT_INITIALIZED = require('ipfs-repo').errors.ERR_REPO_NOT_INITIALIZED;

var IPNS = require('../ipns');

var OfflineDatastore = require('../ipns/routing/offline-datastore');

var initAssets = require('../runtime/init-assets-nodejs');

var PinManager = require('./pin/pin-manager');

var Components = require('./');

module.exports = function (_ref) {
  var apiManager = _ref.apiManager,
      print = _ref.print,
      constructorOptions = _ref.options;
  return /*#__PURE__*/function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var _apiManager$update, cancel, repo, isInitialized, _ref2, peerId, keychain, peerInfo, blockService, ipld, preload, gcLock, dag, object, pinManager, pin, block, add, emptyDirCid, offlineDatastore, ipns, api;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _apiManager$update = apiManager.update({
                init: function init() {
                  throw new AlreadyInitializingError();
                }
              }), cancel = _apiManager$update.cancel;
              _context.prev = 1;
              options = options || {};

              if (typeof constructorOptions.init === 'object') {
                options = mergeOptions(constructorOptions.init, options);
              }

              options.pass = options.pass || constructorOptions.pass;

              if (constructorOptions.config) {
                options.config = mergeOptions(options.config, constructorOptions.config);
              }

              options.repo = options.repo || constructorOptions.repo;
              options.repoAutoMigrate = options.repoAutoMigrate || constructorOptions.repoAutoMigrate;
              repo = typeof options.repo === 'string' || options.repo == null ? createRepo({
                path: options.repo,
                autoMigrate: options.repoAutoMigrate
              }) : options.repo;
              isInitialized = true;

              if (!repo.closed) {
                _context.next = 23;
                break;
              }

              _context.prev = 11;
              _context.next = 14;
              return repo.open();

            case 14:
              _context.next = 23;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](11);

              if (!(_context.t0.code === ERR_REPO_NOT_INITIALIZED)) {
                _context.next = 22;
                break;
              }

              isInitialized = false;
              _context.next = 23;
              break;

            case 22:
              throw _context.t0;

            case 23:
              if (!(!isInitialized && options.allowNew === false)) {
                _context.next = 25;
                break;
              }

              throw new NotEnabledError('new repo initialization is not enabled');

            case 25:
              if (!isInitialized) {
                _context.next = 31;
                break;
              }

              _context.next = 28;
              return initExistingRepo(repo, options);

            case 28:
              _context.t1 = _context.sent;
              _context.next = 34;
              break;

            case 31:
              _context.next = 33;
              return initNewRepo(repo, _objectSpread(_objectSpread({}, options), {}, {
                print: print
              }));

            case 33:
              _context.t1 = _context.sent;

            case 34:
              _ref2 = _context.t1;
              peerId = _ref2.peerId;
              keychain = _ref2.keychain;
              log('peer created');
              peerInfo = new PeerInfo(peerId);
              blockService = new BlockService(repo);
              ipld = new Ipld(getDefaultIpldOptions(blockService, constructorOptions.ipld, log));
              preload = createPreloader(constructorOptions.preload);
              _context.next = 44;
              return preload.start();

            case 44:
              // Make sure GC lock is specific to repo, for tests where there are
              // multiple instances of IPFS
              gcLock = mortice(repo.path, {
                singleProcess: constructorOptions.repoOwner !== false
              });
              dag = {
                get: Components.dag.get({
                  ipld: ipld,
                  preload: preload
                }),
                resolve: Components.dag.resolve({
                  ipld: ipld,
                  preload: preload
                }),
                tree: Components.dag.tree({
                  ipld: ipld,
                  preload: preload
                })
              };
              object = {
                data: Components.object.data({
                  ipld: ipld,
                  preload: preload
                }),
                get: Components.object.get({
                  ipld: ipld,
                  preload: preload
                }),
                links: Components.object.links({
                  dag: dag
                }),
                new: Components.object.new({
                  ipld: ipld,
                  preload: preload
                }),
                patch: {
                  addLink: Components.object.patch.addLink({
                    ipld: ipld,
                    gcLock: gcLock,
                    preload: preload
                  }),
                  appendData: Components.object.patch.appendData({
                    ipld: ipld,
                    gcLock: gcLock,
                    preload: preload
                  }),
                  rmLink: Components.object.patch.rmLink({
                    ipld: ipld,
                    gcLock: gcLock,
                    preload: preload
                  }),
                  setData: Components.object.patch.setData({
                    ipld: ipld,
                    gcLock: gcLock,
                    preload: preload
                  })
                },
                put: Components.object.put({
                  ipld: ipld,
                  gcLock: gcLock,
                  preload: preload
                }),
                stat: Components.object.stat({
                  ipld: ipld,
                  preload: preload
                })
              };
              pinManager = new PinManager(repo, dag);
              _context.next = 50;
              return pinManager.load();

            case 50:
              pin = {
                add: Components.pin.add({
                  pinManager: pinManager,
                  gcLock: gcLock,
                  dag: dag
                }),
                ls: Components.pin.ls({
                  pinManager: pinManager,
                  dag: dag
                }),
                rm: Components.pin.rm({
                  pinManager: pinManager,
                  gcLock: gcLock,
                  dag: dag
                })
              }; // FIXME: resolve this circular dependency

              dag.put = Components.dag.put({
                ipld: ipld,
                pin: pin,
                gcLock: gcLock,
                preload: preload
              });
              block = {
                get: Components.block.get({
                  blockService: blockService,
                  preload: preload
                }),
                put: Components.block.put({
                  blockService: blockService,
                  pin: pin,
                  gcLock: gcLock,
                  preload: preload
                }),
                rm: Components.block.rm({
                  blockService: blockService,
                  gcLock: gcLock,
                  pinManager: pinManager
                }),
                stat: Components.block.stat({
                  blockService: blockService,
                  preload: preload
                })
              };
              add = Components.add({
                block: block,
                preload: preload,
                pin: pin,
                gcLock: gcLock,
                options: constructorOptions
              });

              if (!(!isInitialized && !options.emptyRepo)) {
                _context.next = 66;
                break;
              }

              _context.next = 57;
              return addEmptyDir({
                dag: dag
              });

            case 57:
              emptyDirCid = _context.sent;
              log('adding default assets');
              _context.next = 61;
              return initAssets({
                add: add,
                print: print
              });

            case 61:
              log('initializing IPNS keyspace'); // Setup the offline routing for IPNS.
              // This is primarily used for offline ipns modifications, such as the initializeKeyspace feature.

              offlineDatastore = new OfflineDatastore(repo);
              ipns = new IPNS(offlineDatastore, repo.datastore, peerInfo, keychain, {
                pass: options.pass
              });
              _context.next = 66;
              return ipns.initializeKeyspace(peerId.privKey, emptyDirCid.toString());

            case 66:
              api = createApi({
                add: add,
                apiManager: apiManager,
                constructorOptions: constructorOptions,
                block: block,
                blockService: blockService,
                dag: dag,
                gcLock: gcLock,
                initOptions: options,
                ipld: ipld,
                keychain: keychain,
                object: object,
                peerInfo: peerInfo,
                pin: pin,
                pinManager: pinManager,
                preload: preload,
                print: print,
                repo: repo
              });
              apiManager.update(api, function () {
                throw new NotStartedError();
              });
              _context.next = 74;
              break;

            case 70:
              _context.prev = 70;
              _context.t2 = _context["catch"](1);
              cancel();
              throw _context.t2;

            case 74:
              return _context.abrupt("return", apiManager.api);

            case 75:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 70], [11, 16]]);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }();
};

function initNewRepo(_x2, _x3) {
  return _initNewRepo.apply(this, arguments);
}

function _initNewRepo() {
  _initNewRepo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(repo, _ref3) {
    var privateKey, emptyRepo, bits, profiles, config, pass, print, exists, peerId, keychain, keychainOptions;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            privateKey = _ref3.privateKey, emptyRepo = _ref3.emptyRepo, bits = _ref3.bits, profiles = _ref3.profiles, config = _ref3.config, pass = _ref3.pass, print = _ref3.print;
            emptyRepo = emptyRepo || false;
            bits = bits == null ? 2048 : Number(bits);
            config = mergeOptions(applyProfiles(profiles, getDefaultConfig()), config); // Verify repo does not exist yet

            _context4.next = 6;
            return repo.exists();

          case 6:
            exists = _context4.sent;
            log('repo exists?', exists);

            if (!(exists === true)) {
              _context4.next = 10;
              break;
            }

            throw new Error('repo already exists');

          case 10:
            _context4.next = 12;
            return createPeerId({
              privateKey: privateKey,
              bits: bits,
              print: print
            });

          case 12:
            peerId = _context4.sent;
            keychain = new NoKeychain();
            log('identity generated');
            config.Identity = {
              PeerID: peerId.toB58String(),
              PrivKey: peerId.privKey.bytes.toString('base64')
            };
            privateKey = peerId.privKey;
            config.Keychain = Keychain.generateOptions();
            log('peer identity: %s', config.Identity.PeerID);
            _context4.next = 21;
            return repo.init(config);

          case 21:
            _context4.next = 23;
            return repo.open();

          case 23:
            log('repo opened');

            if (!pass) {
              _context4.next = 30;
              break;
            }

            log('creating keychain');
            keychainOptions = _objectSpread({
              passPhrase: pass
            }, config.Keychain);
            keychain = new Keychain(repo.keys, keychainOptions);
            _context4.next = 30;
            return keychain.importPeer('self', {
              privKey: privateKey
            });

          case 30:
            return _context4.abrupt("return", {
              peerId: peerId,
              keychain: keychain
            });

          case 31:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _initNewRepo.apply(this, arguments);
}

function initExistingRepo(_x4, _x5) {
  return _initExistingRepo.apply(this, arguments);
}

function _initExistingRepo() {
  _initExistingRepo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(repo, _ref4) {
    var newConfig, profiles, pass, config, keychain, keychainOptions, peerId;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            newConfig = _ref4.config, profiles = _ref4.profiles, pass = _ref4.pass;
            _context5.next = 3;
            return repo.config.get();

          case 3:
            config = _context5.sent;

            if (!(newConfig || profiles)) {
              _context5.next = 9;
              break;
            }

            if (profiles) {
              config = applyProfiles(profiles, config);
            }

            if (newConfig) {
              config = mergeOptions(config, newConfig);
            }

            _context5.next = 9;
            return repo.config.set(config);

          case 9:
            keychain = new NoKeychain();

            if (pass) {
              keychainOptions = _objectSpread({
                passPhrase: pass
              }, config.Keychain);
              keychain = new Keychain(repo.keys, keychainOptions);
              log('keychain constructed');
            }

            _context5.next = 13;
            return PeerId.createFromPrivKey(config.Identity.PrivKey);

          case 13:
            peerId = _context5.sent;

            if (!pass) {
              _context5.next = 25;
              break;
            }

            _context5.prev = 15;
            _context5.next = 18;
            return keychain.findKeyByName('self');

          case 18:
            _context5.next = 25;
            break;

          case 20:
            _context5.prev = 20;
            _context5.t0 = _context5["catch"](15);
            log('Creating "self" key');
            _context5.next = 25;
            return keychain.importPeer('self', peerId);

          case 25:
            return _context5.abrupt("return", {
              peerId: peerId,
              keychain: keychain
            });

          case 26:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[15, 20]]);
  }));
  return _initExistingRepo.apply(this, arguments);
}

function createPeerId(_ref5) {
  var privateKey = _ref5.privateKey,
      bits = _ref5.bits,
      print = _ref5.print;

  if (privateKey) {
    log('using user-supplied private-key');
    return typeof privateKey === 'object' ? privateKey : PeerId.createFromPrivKey(Buffer.from(privateKey, 'base64'));
  } else {
    // Generate peer identity keypair + transform to desired format + add to config.
    print('generating %s-bit RSA keypair...', bits);
    return PeerId.create({
      bits: bits
    });
  }
}

function addEmptyDir(_ref6) {
  var dag = _ref6.dag;
  var node = new DAGNode(new UnixFs('directory').marshal());
  return dag.put(node, {
    version: 0,
    format: multicodec.DAG_PB,
    hashAlg: multicodec.SHA2_256,
    preload: false
  });
} // Apply profiles (e.g. ['server', 'lowpower']) to config


function applyProfiles(profiles, config) {
  return (profiles || []).reduce(function (config, name) {
    var profile = require('./config').profiles[name];

    if (!profile) {
      throw new Error("Could not find profile with name '".concat(name, "'"));
    }

    log('applying profile %s', name);
    return profile.transform(config);
  }, config);
}

function createApi(_ref7) {
  var add = _ref7.add,
      apiManager = _ref7.apiManager,
      constructorOptions = _ref7.constructorOptions,
      block = _ref7.block,
      blockService = _ref7.blockService,
      dag = _ref7.dag,
      gcLock = _ref7.gcLock,
      initOptions = _ref7.initOptions,
      ipld = _ref7.ipld,
      keychain = _ref7.keychain,
      object = _ref7.object,
      peerInfo = _ref7.peerInfo,
      pin = _ref7.pin,
      pinManager = _ref7.pinManager,
      preload = _ref7.preload,
      print = _ref7.print,
      repo = _ref7.repo;

  var notStarted = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new NotStartedError();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function notStarted() {
      return _ref8.apply(this, arguments);
    };
  }();

  var resolve = Components.resolve({
    ipld: ipld
  });
  var refs = Components.refs({
    ipld: ipld,
    resolve: resolve,
    preload: preload
  });
  refs.local = Components.refs.local({
    repo: repo
  });
  var api = {
    add: add,
    bitswap: {
      stat: notStarted,
      unwant: notStarted,
      wantlist: notStarted
    },
    bootstrap: {
      add: Components.bootstrap.add({
        repo: repo
      }),
      list: Components.bootstrap.list({
        repo: repo
      }),
      rm: Components.bootstrap.rm({
        repo: repo
      })
    },
    block: block,
    cat: Components.cat({
      ipld: ipld,
      preload: preload
    }),
    config: Components.config({
      repo: repo
    }),
    dag: dag,
    dns: Components.dns(),
    files: Components.files({
      ipld: ipld,
      block: block,
      blockService: blockService,
      repo: repo,
      preload: preload,
      options: constructorOptions
    }),
    get: Components.get({
      ipld: ipld,
      preload: preload
    }),
    id: Components.id({
      peerInfo: peerInfo
    }),
    init: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new AlreadyInitializedError();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function init() {
        return _init2.apply(this, arguments);
      }

      return init;
    }(),
    // eslint-disable-line require-await
    isOnline: Components.isOnline({}),
    key: {
      export: Components.key.export({
        keychain: keychain
      }),
      gen: Components.key.gen({
        keychain: keychain
      }),
      import: Components.key.import({
        keychain: keychain
      }),
      info: Components.key.info({
        keychain: keychain
      }),
      list: Components.key.list({
        keychain: keychain
      }),
      rename: Components.key.rename({
        keychain: keychain
      }),
      rm: Components.key.rm({
        keychain: keychain
      })
    },
    ls: Components.ls({
      ipld: ipld,
      preload: preload
    }),
    object: object,
    pin: pin,
    refs: refs,
    repo: {
      gc: Components.repo.gc({
        gcLock: gcLock,
        pin: pin,
        pinManager: pinManager,
        refs: refs,
        repo: repo
      }),
      stat: Components.repo.stat({
        repo: repo
      }),
      version: Components.repo.version({
        repo: repo
      })
    },
    resolve: resolve,
    start: Components.start({
      apiManager: apiManager,
      options: constructorOptions,
      blockService: blockService,
      gcLock: gcLock,
      initOptions: initOptions,
      ipld: ipld,
      keychain: keychain,
      peerInfo: peerInfo,
      pinManager: pinManager,
      preload: preload,
      print: print,
      repo: repo
    }),
    stats: {
      bitswap: notStarted,
      bw: notStarted,
      repo: Components.repo.stat({
        repo: repo
      })
    },
    stop: function stop() {},
    swarm: {
      addrs: notStarted,
      connect: notStarted,
      disconnect: notStarted,
      localAddrs: Components.swarm.localAddrs({
        peerInfo: peerInfo
      }),
      peers: notStarted
    },
    version: Components.version({
      repo: repo
    })
  };
  return api;
}